import { productAddToCart as productAction } from '../../eventData/actionProduct.data';
import { baseProductData } from '../../eventData/baseProduct.data';
import { parseCartData } from '../../eventData/cartItems.data';
import { getGeneralEventData } from '../../eventData/general.data';
import { parseOrderData } from '../../eventData/orderItems.data';
import { EVENT_TYPES } from './MatomoTagManager.events.js';

/** @namespace Bodymod/Matomo/Component/MatomoTagManger/MatomoTagManager/EventsManager/transformGeneralData */
export function transformGeneralData(data) {
    return {
        event: EVENT_TYPES.GENERAL,
        ...getGeneralEventData(data)
    };
}

/** @namespace Bodymod/Matomo/Component/MatomoTagManger/MatomoTagManager/EventsManager/transformProductViewData */
export function transformProductViewData(data) {
    return {
        event: EVENT_TYPES.PRODUCT_VIEW,
        ecommerce: {
            currencyCode: data.currencyCode,
            detail: {
                products: baseProductData({ product: data }, true)
            }
        }
    };
}

/** @namespace Bodymod/Matomo/Component/MatomoTagManger/MatomoTagManager/EventsManager/transformAddToCartData */
export function transformAddToCartData(data) {
    return {
        event: EVENT_TYPES.ADD_TO_CART,
        ecommerce: {
            currencyCode: data.currencyCode,
            add: {
                products: productAction(data)
            }
        }
    };
}

/** @namespace Bodymod/Matomo/Component/MatomoTagManger/MatomoTagManager/EventsManager/transformCartUpdateData */
export function transformCartUpdateData(data) {
    return {
        event: EVENT_TYPES.CART_UPDATE,
        ecommerce: {
            currencyCode: data.currencyCode,
            cart: {
                products: parseCartData(data.items)
            }
        }
    };
}

/** @namespace Bodymod/Matomo/Component/MatomoTagManger/MatomoTagManager/EventsManager/transformCartTotalData */
export function transformCartTotalData(data) {
    return {
        event: EVENT_TYPES.CART_TOTAL,
        currencyCode: data.currencyCode,
        cartTotal: data.grand_total
    };
}

/** @namespace Bodymod/Matomo/Component/MatomoTagManger/MatomoTagManager/EventsManager/transformOrderUpdateData */
export function transformOrderUpdateData(data) {
    return {
        event: EVENT_TYPES.ORDER_UPDATE,
        ecommerce: {
            currencyCode: data.currencyCode,
            purchase: {
                products: parseOrderData(data?.purchase?.products || [])
            }
        }
    };
}

/** @namespace Bodymod/Matomo/Component/MatomoTagManger/MatomoTagManager/EventsManager/transformPurchaseData */
export function transformPurchaseData(data) {
    const {
        currencyCode,
        orderID: orderId,
        purchase: {
            products = [],
            revenue: grandTotal,
            tax,
            shipping
        } = {}
    } = data || {};

    return {
        event: EVENT_TYPES.PURCHASE,
        ecommerce: {
            currencyCode,
            purchase: {
                products: parseOrderData(products),
                orderId,
                grandTotal: +grandTotal,
                subTotal: null,
                tax: +tax,
                shipping: +shipping
            }
        }
    };
}

export const eventTransformationMap = {
    [EVENT_TYPES.GENERAL]: transformGeneralData,
    [EVENT_TYPES.PRODUCT_VIEW]: transformProductViewData,
    [EVENT_TYPES.ADD_TO_CART]: transformAddToCartData,
    [EVENT_TYPES.CART_UPDATE]: transformCartUpdateData,
    [EVENT_TYPES.CART_TOTAL]: transformCartTotalData,
    [EVENT_TYPES.ORDER_UPDATE]: transformOrderUpdateData,
    [EVENT_TYPES.PURCHASE]: transformPurchaseData
};
